import React from 'react'
import { addToast, ToastContent } from '@mobi/component-library/Feedback/Toast'
import { MfaError, MFAMethod, MFAServerMethod } from '@mobi/api-types/src/mfa'

export function handleMfaError(
  mfaError: MfaError,
  operation: 'verification' | 'update' | 'complete' = 'verification'
): void {
  const { status, error, message } = mfaError

  // Handle rate limiting (429)

  if (status === 429 || error === 'LimitExceededException') {
    addToast({
      id: 'mfa-rate-limit-error',
      isDismissable: true,
      isFullWidth: true,
      content: (
        <ToastContent
          title='Too many verification attempts'
          subtitle='Please try again later'
          icon='warning'
        />
      ),
    })
    return
  }

  // Handle expired code
  if (error === 'ExpiredCodeException' || (message && message.includes('expired'))) {
    addToast({
      id: 'mfa-expired-code-error',
      isDismissable: true,
      isFullWidth: true,
      content: (
        <ToastContent
          title='Your verification code has expired'
          subtitle='Please request a new code'
          icon='error'
        />
      ),
    })
    return
  }

  // Handle code mismatch
  if (error === 'CodeMismatchException' || (message && message.includes('match'))) {
    addToast({
      id: 'mfa-code-mismatch-error',
      isDismissable: true,
      isFullWidth: true,
      content: (
        <ToastContent
          title='Incorrect verification code'
          subtitle='Please check and try again'
          icon='error'
        />
      ),
    })
    return
  }

  // Handle invalid parameter
  if (error === 'InvalidParameterException') {
    addToast({
      id: 'mfa-invalid-parameter-error',
      isDismissable: true,
      isFullWidth: true,
      content: (
        <ToastContent
          title='Invalid verification code format'
          subtitle='Please check and try again'
          icon='error'
        />
      ),
    })
    return
  }

  if (status === 403 || error === 'Forbidden' || error === 'NotAuthorizedException') {
    addToast({
      id: 'mfa-authentication-error',
      isDismissable: true,
      isFullWidth: true,
      content: (
        <ToastContent title='Authentication failed' subtitle='Please try again.' icon='error' />
      ),
    })
    return
  }

  // Default error handling
  const operationText = {
    verification: 'initiate verification',
    update: 'update MFA settings',
    complete: 'verify code',
  }[operation]

  addToast({
    id: `mfa-${operation}-error`,
    isDismissable: true,
    isFullWidth: true,
    content: (
      <ToastContent
        title={`Failed to ${operationText}`}
        subtitle={message || 'Please try again'}
        icon='error'
      />
    ),
  })
}

export function mfaCodeText(displayFactor: MFAMethod | MFAServerMethod, contactDetail: string) {
  const baseText = 'To access your account, enter the 6 digit code we sent to'
  switch (displayFactor) {
    case 'SMS':
      return `${baseText} your mobile number ${contactDetail}.`
    case 'EMAIL':
    case 'Email':
      return `${baseText} your email address ${contactDetail}.`
    default:
      return `${baseText} ${contactDetail}.`
  }
}
